export default __webpack_public_path__ + "static/media/auditorium_image.df05ea07.jpg";